import React from "react";

function Card({ title, value }) {
  return (
    <div className="p-4 bg-grayish rounded-2xl shadow-md">
      <div className="text-sm text-gray-500">{title}</div>
      <div className="text-xl font-bold text-main1">{value}</div>
    </div>
  );
}

export default Card;
